import { call, put, takeLatest } from 'redux-saga/effects';
import axiosInstance from 'services/AuthHeader';
import { setSignInError } from 'redux/reducers/authorization';
import { setSending, unsetSending } from 'redux/reducers/serverCommunication';
import { userSignedInAction } from "redux/sagas/userSignedInSaga";

export const SAGA_SIGN_IN = 'SAGA_SIGN_IN';

export function signInSaga(credentials) {
  return { type: SAGA_SIGN_IN, credentials };
}

const handleSignIn = async ({ username, password }) =>
  axiosInstance.post('/api/auth/login', { username, password }).then((res) => res.data);

export function* signIn(action) {
  yield put(setSending);
  try {
    const response = yield call(handleSignIn, action.credentials);
    yield put(userSignedInAction(response))
  } catch (e) {
    yield put(setSignInError(e.response?.data));
  } finally {
    yield put(unsetSending);
  }
}

export function* watchForSignIn() {
  yield takeLatest(SAGA_SIGN_IN, signIn);
}
